<div class="table-prompt">
  @if (activatedPrompt && showPrompt) {
    <div [ngClass]="setCustomClasses()">
      <span class="table-prompt__text">
        <span class="table-prompt__animation">
          @if (activatedPrompt.type === 'success') {
            <i class="icon icon--medium">{{
              activatedPrompt.icon || 'check_circle_outline'
            }}</i>
          }
          @if (activatedPrompt.type === 'error') {
            <i class="icon icon--medium">{{
              activatedPrompt.icon || 'error_outline'
            }}</i>
          }
          {{ activatedPrompt.message }}
        </span>
      </span>
      <span class="table-prompt__text close-prompt">
        @if (activatedPrompt?.action) {
          <a
            class="icon--medium t-bold action-prompt"
            (click)="triggerPromptAction(activatedPrompt.action)"
            (keydown.enter)="triggerPromptAction(activatedPrompt.action)"
            tabindex="0"
            >{{ activatedPrompt?.action?.label }}</a
          >
        }
        <i
          class="icon icon--medium"
          (click)="closePrompt()"
          (keydown.enter)="closePrompt()"
          tabindex="0"
          >close</i
        >
      </span>
    </div>
  }
</div>
